import script from "./sidebar-insights-property.vue?vue&type=script&setup=true&lang=ts"
export * from "./sidebar-insights-property.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__